<mat-toolbar class="cl-sub-toolbar" color="primary">
    <ng-content></ng-content>
    <nav-toolbar [currentTitleOverride]="currentTitle"></nav-toolbar>
</mat-toolbar>
